import { tns } from 'tiny-slider/src/tiny-slider';
import Isotope from 'isotope-layout';
import Swiper, { Navigation } from 'swiper';

const throttle = (fn, wait) => {
  let time = Date.now();

  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  const masthead = document.querySelector('.masthead');
  const burger = document.querySelector('.masthead--hamburger');
  const nav = document.querySelector('.masthead--navigation');

  burger.addEventListener('click', function () {
    this.classList.toggle('is-active');
    nav.classList.toggle('toggled');
  });

  masthead.classList.toggle('scrolled', window.scrollY > 100);
  window.addEventListener(
    'scroll',
    throttle(() => {
      masthead.classList.toggle('scrolled', window.scrollY > 100);
    }, 30)
  );

  document.querySelectorAll('.menu-item-has-children a[href="#"]').forEach((el) => {
    const ul = el.parentElement.querySelector('ul');

    el.addEventListener('click', (event) => {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      if (vw >= 992) {
        return;
      }

      event.preventDefault();

      ul.classList.toggle('toggled');
      el.classList.toggle('toggled');
    });
  });

  if (document.body.classList.contains('home')) {
    // testimonials slider
    new Swiper('.home-testimonials--slider', {
      modules: [Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 64,
      navigation: {
        prevEl: '.home-testimonials--slider .swiper-buttons-prev',
        nextEl: '.home-testimonials--slider .swiper-buttons-next',
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 128,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
      },
    });

    // team sliders
    let autoplayTimeout = 4000;

    document.querySelectorAll('.home-team--gallery-item-slider').forEach((el) => {
      tns({
        container: el,
        items: 1,
        loop: true,
        nav: false,
        controls: false,
        edgePadding: 0,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: autoplayTimeout,
      });

      autoplayTimeout = autoplayTimeout + 1000;
    });
  } else if (document.body.classList.contains('page-template-template-locations')) {
    const commonSliderSetting = {
      controls: false,
      autoplayButtonOutput: false,
      nav: false,
      speed: 500,
      touch: false,
    };

    const locationsTeamSectionSliderParts = ['contact', 'images', 'header', 'people'];

    const locationsTeamSectionSliders = locationsTeamSectionSliderParts.map((el) => {
      const additionalSettings = {};

      if (el === 'images') {
        additionalSettings.mode = 'gallery';
        additionalSettings.speed = 1000;
      }

      return tns({
        container: `.page-locations--team-${el}`,
        ...commonSliderSetting,
        ...additionalSettings,
      });
    });

    document.querySelector('.page-locations--team-arrows-prev').addEventListener('click', (event) => {
      event.preventDefault();

      locationsTeamSectionSliders.forEach((slider) => slider.goTo('prev'));
    });

    document.querySelector('.page-locations--team-arrows-next').addEventListener('click', (event) => {
      event.preventDefault();

      locationsTeamSectionSliders.forEach((slider) => slider.goTo('next'));
    });

    const locationSliders = document.querySelector('.page-locations--team');

    document.querySelectorAll('.page-locations--main-item-main a').forEach((el) => {
      const { locationId } = el.dataset;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        locationsTeamSectionSliders.forEach((slider) => slider.goTo(locationId));

        locationSliders.scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
  } else if (document.body.classList.contains('page-template-template-team')) {
    const grid = document.querySelector('.page-team--list');
    const iso = new Isotope(grid, {
      itemSelector: '.page-team--list-item',
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 16,
      },
    });

    const filterButtons = document.querySelectorAll('.page-team--filters button');
    const langsButtons = document.querySelectorAll('.page-team--langs button');

    const queryVarFilter = document.querySelector('#salon').value;

    filterButtons.forEach((el) => {
      const location = el.dataset.filter;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        filterButtons.forEach((b) => b.classList.remove('active'));
        el.classList.add('active');

        // const lang = document.querySelector('.page-team--langs button.active')?.dataset.filter;

        // const filter = lang ? `${lang}${location}` : location;

        langsButtons.forEach((el2) => {
          el2.classList.remove('active');
        });

        iso.arrange({
          filter: location,
        });
      });
    });

    filterButtons.forEach((el) => {
      const location = el.dataset.filter;

      if (location == queryVarFilter) {
        el.click();
      }
    });

    // langs
    langsButtons.forEach((el) => {
      const lang = el.dataset.filter;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        const location = document.querySelector('.page-team--filters button.active').dataset.filter;

        langsButtons.forEach((b) => b.classList.remove('active'));
        el.classList.add('active');

        const filter = location === '*' ? lang : `${lang}${location}`;

        iso.arrange({
          filter,
        });
      });
    });
  } else if (document.body.classList.contains('page-template-template-team-item')) {
    const footer = document.querySelector('.mastfoot--maps');

    document.querySelector('.page-team-item--location-main h3 a').addEventListener('click', (event) => {
      event.preventDefault();

      footer.scrollIntoView({
        behavior: 'smooth',
      });
    });
  } else if (document.body.classList.contains('page-template-template-pricelist')) {
    const slider = tns({
      container: '.page-pricelist--main-categories',
      mode: 'gallery',
      items: 1,
      loop: true,
      autoplayButtonOutput: false,
      mouseDrag: false,
      nav: false,
      controls: false,
    });

    const navItems = document.querySelectorAll('.page-pricelist--nav-items a');

    navItems.forEach((el) => {
      const { id } = el.dataset;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        slider.goTo(id);

        navItems.forEach((item) => {
          item.classList.remove('active');
        });

        el.classList.add('active');
      });
    });
  } else if (document.body.classList.contains('page-template-template-pricelist-v2')) {
    const slider = tns({
      container: '.page-pricelist-v2--main-categories',
      mode: 'gallery',
      items: 1,
      loop: true,
      autoplayButtonOutput: false,
      mouseDrag: false,
      nav: false,
      controls: false,
    });

    let dirty = false;

    const navItems = document.querySelectorAll('.page-pricelist-v2--nav-items a');
    const extraNavItems = document.querySelectorAll('.page-pricelist-v2--extra-nav-items a');

    navItems.forEach((el) => {
      const { id } = el.dataset;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        slider.goTo(id);

        if (!dirty) {
          document.querySelector('.page-pricelist-v2--main').classList.add('dirty');
          dirty = true;
        }

        navItems.forEach((item) => {
          item.classList.remove('active');
        });

        extraNavItems.forEach((item) => {
          item.classList.remove('active');
        });

        extraNavItems[id].classList.add('active');

        el.classList.add('active');
      });
    });

    extraNavItems.forEach((el) => {
      const { id } = el.dataset;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        slider.goTo(id);

        if (!dirty) {
          document.querySelector('.page-pricelist-v2--main').classList.add('dirty');
          dirty = true;
        }

        navItems.forEach((item) => {
          item.classList.remove('active');
        });

        extraNavItems.forEach((item) => {
          item.classList.remove('active');
        });

        navItems[id].classList.add('active');

        el.classList.add('active');
      });
    });

    const threshold = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 992 ? 0.15 : 0.3;

    const pricelistMain = document.querySelector('.page-pricelist-v2--main');
    const extraNav = document.querySelector('.page-pricelist-v2--extra-nav');
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            extraNav.classList.add('toggled');
          } else {
            extraNav.classList.remove('toggled');
          }
        }
      },
      {
        rootMargin: '45% 0px 0px 0px',
        threshold: threshold,
      }
    );

    observer.observe(pricelistMain);
  } else if (document.body.classList.contains('page-template-template-contact')) {
    const slider = tns({
      container: '.page-contact--main-locations',
      mode: 'gallery',
      items: 1,
      loop: true,
      autoplayButtonOutput: false,
      mouseDrag: false,
      nav: false,
      controls: false,
    });

    const navItems = document.querySelectorAll('.page-contact--nav-items a');

    navItems.forEach((el) => {
      const { id } = el.dataset;

      el.addEventListener('click', (event) => {
        event.preventDefault();

        slider.goTo(id);

        navItems.forEach((item) => {
          item.classList.remove('active');
        });

        el.classList.add('active');
      });
    });
  }
});
